var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0%",
    x2: "92.2525491%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.3796734%",
    y1: "0%",
    x2: "87.0262485%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "staker---staking-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-6",
    transform: "translate(-123.000000, -47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cosmos-logo-horizontal-dark",
    transform: "translate(124.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9999365,0 C58.9867462,0 76,17.0131586 76,37.9999365 C76,58.9867462 58.9867462,76 37.9999365,76 C17.0131586,76 0,58.9867462 0,37.9999365 C0,17.0131586 17.0131586,0 37.9999365,0 Z",
    id: "Path",
    strokeOpacity: 0.2,
    stroke: "#00F3AB",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "polkadot-new-dot-logo",
    transform: "translate(18.216994, 17.000000)",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.283006,9 C23.4251416,9 26.783006,6.98528137 26.783006,4.5 C26.783006,2.01471863 23.4251416,0 19.283006,0 C15.1408704,0 11.783006,2.01471863 11.783006,4.5 C11.783006,6.98528137 15.1408704,9 19.283006,9 Z M19.283006,42 C23.4251416,42 26.783006,39.9852814 26.783006,37.5 C26.783006,35.0147186 23.4251416,33 19.283006,33 C15.1408704,33 11.783006,35.0147186 11.783006,37.5 C11.783006,39.9852814 15.1408704,42 19.283006,42 Z M9.15229093,14.9072611 C11.2341795,11.2848524 11.2206671,7.36158176 9.12209016,6.14437338 C7.02350806,4.92717387 3.63455076,6.87696699 1.55261706,10.4993496 C-0.529271546,14.1217583 -0.515759148,18.0450289 1.58281783,19.2622373 C3.68139993,20.4794368 7.07035724,18.5296437 9.15229093,14.9072611 Z M37.7616191,31.5003734 C39.8435077,27.8779647 39.8311448,23.9553608 37.7339857,22.7389749 C35.6368216,21.5225978 32.2490138,23.4730576 30.1670801,27.0954402 C28.0851915,30.7178489 28.0975544,34.6404528 30.1947134,35.8568388 C32.2918776,37.0732159 35.6796854,35.122756 37.7616191,31.5003734 Z M9.12313967,35.8558291 C11.2217167,34.6386208 11.2352291,30.7153501 9.15334044,27.0929415 C7.07140675,23.4705588 3.68244944,21.5207657 1.58386734,22.7379652 C-0.514709639,23.9551736 -0.528222037,27.8784442 1.55366657,31.5008529 C3.63560027,35.1232355 7.02455757,37.0730287 9.12313967,35.8558291 Z M37.7357616,19.2632023 C39.8329206,18.0468163 39.8452835,14.1242124 37.763395,10.5018037 C35.6814612,6.87942111 32.2936534,4.92896128 30.1964893,6.14533836 C28.0993303,7.3617243 28.0869673,11.2843282 30.1688559,14.9067369 C32.2507896,18.5291195 35.6385975,20.4795794 37.7357616,19.2632023 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.06fb9c613fe4f531d043fb7e421f30e9.svg";
export { ForwardRef as ReactComponent };